import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
}

const DragIndicatorIcon: React.FC<Props> = ({ className }) => {
  return (
    <SVGIcon
      width="21"
      height="20"
      viewBox="0 0 21 20"
      ariaHidden={true}
      className={className}
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 14.0001C8.60457 14.0001 9.5 14.8956 9.5 16.0001C9.5 17.1047 8.60457 18.0001 7.5 18.0001C6.39543 18.0001 5.5 17.1047 5.5 16.0001C5.5 14.8956 6.39543 14.0001 7.5 14.0001ZM13.5 14.0001C14.6046 14.0001 15.5 14.8956 15.5 16.0001C15.5 17.1047 14.6046 18.0001 13.5 18.0001C12.3954 18.0001 11.5 17.1047 11.5 16.0001C11.5 14.8956 12.3954 14.0001 13.5 14.0001ZM7.5 8.00012C8.60457 8.00012 9.5 8.89555 9.5 10.0001C9.5 11.1047 8.60457 12.0001 7.5 12.0001C6.39543 12.0001 5.5 11.1047 5.5 10.0001C5.5 8.89555 6.39543 8.00012 7.5 8.00012ZM13.5 8.00012C14.6046 8.00012 15.5 8.89555 15.5 10.0001C15.5 11.1047 14.6046 12.0001 13.5 12.0001C12.3954 12.0001 11.5 11.1047 11.5 10.0001C11.5 8.89555 12.3954 8.00012 13.5 8.00012ZM7.5 2.00012C8.60457 2.00012 9.5 2.89555 9.5 4.00012C9.5 5.10469 8.60457 6.00012 7.5 6.00012C6.39543 6.00012 5.5 5.10469 5.5 4.00012C5.5 2.89555 6.39543 2.00012 7.5 2.00012ZM13.5 2.00012C14.6046 2.00012 15.5 2.89555 15.5 4.00012C15.5 5.10469 14.6046 6.00012 13.5 6.00012C12.3954 6.00012 11.5 5.10469 11.5 4.00012C11.5 2.89555 12.3954 2.00012 13.5 2.00012Z"
      />
    </SVGIcon>
  );
};

export default DragIndicatorIcon;
